/**
 * App Root Component
 * CCH Care - Version 1.0
 */

import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './features/auth/useAuth';
import CareRouter from './components/routing/CareRouter';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CareRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
